import { createSlotRecipe } from './runtime.js';

const fallbackPageConfig = {"name":"fallbackPage","slots":["root","contentsWrapper","graphic","textWrapper","text","title","description","actions"]}

export const fallbackPage = /* @__PURE__ */ createSlotRecipe(fallbackPageConfig)